module.exports = __webpack_public_path__ + "img/HR.e2068350.png";